import React from "react";
import styled from "styled-components/macro";
import { Link } from "react-router-dom";

export const Service = ({ img, title, introText, linkTo }) => {
  return (
    <>
      <ServiceCard>
        <img src={img} alt="Kvinnor inom Tech & IT" />
        <h2>{title}</h2>
        <p>{introText}</p>
        <Link to={linkTo}>
          <Button> Läs mer </Button>
        </Link>
      </ServiceCard>
    </>
  );
};

const ServiceCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  width: 400px;
  margin: 40px;
  padding: 20px;
  background: #f5f5f5;
  box-shadow: 0 5px 5px #C4C4C4;
  transition: box-shadow 0.5s ease;
  text-align: center;

  :hover {
    box-shadow: 5px 5px 10px #C4C4C4;
  }

  @media (max-width: 480px) {
    margin: 20px 0;
    padding: 10px;
    max-width: 350px;
  }

  @media (max-width: 320px) {
    max-width: 250px;
  }

  img {
    max-width: 90%;
    margin-bottom: 10px;
  }

  h2{
    @media (max-width: 381px) {
      font-size: 20px;
    }
  }
`;

const Button = styled.button`
  padding: 10px 50px;
  margin: 10px;
  border-radius: 5px;
  border: none;
  background: #f07666;
  color: #fff;
  font-family: "Poppins", sans-serif;
  font-weight: bold;
  font-size: 18px;
  transition: all 0.3s;
  :hover {
    background-color: #ff9767;
    cursor: pointer;
  }
`;
